import { render, staticRenderFns } from "./DeleteItemVocabulary.vue?vue&type=template&id=e2bf3b70&scoped=true&"
import script from "./DeleteItemVocabulary.vue?vue&type=script&lang=js&"
export * from "./DeleteItemVocabulary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bf3b70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
